<template lang="pug">
  section.comic
    h1.title {{ issue.title }}
    img( 
      :src="slide.url" 
      :aria-label="slide.metadata || slide.url" :alt="slide.metadata || slide.url"
      @load="onImageLoad" 
      :loading="loading"
    )
    
    div.controls
    
      //- router-link( :to="getSlideRoute(0)" desktop ) &#91; first
      router-link( :to="getSlideRoute(0)" mobile ) &lt;&lt;

      //- router-link( 
      //-   :to="getSlideRoute(key - 1)"
      //-   :class="{ hide: key - 1 < 0 }"
      //-   desktop
      //- ) &lt; prev

      router-link( 
        :to="getSlideRoute(key - 1)"
        :class="{ hide: key - 1 < 0 }"
        mobile
      ) &lt;

      p
        //- span( desktop ) | 🍓 
        span( mobile ) 🍓 
        router-link.blue(
          :to="`/comic/${comic.name}`"
        ) \#{{ $route.params.slide }}
        //- span( desktop )  🍓 |
        span( mobile )  🍓

      //- router-link( 
      //-   :to="getSlideRoute(key + 1)"
      //-   :class="{ hide: key + 1 === issue.slides.length }"
      //-   desktop
      //- ) next &gt;

      router-link( 
        :to="getSlideRoute(key + 1)"
        :class="{ hide: key + 1 === issue.slides.length }"
        mobile
      ) &gt;

      //- router-link( :to="getSlideRoute(issue.slides.length - 1)" desktop ) last &#93;
      router-link( :to="getSlideRoute(issue.slides.length - 1)" mobile ) &gt;&gt;
      
    p.note( v-if="slide.note" v-html="slide.note" )
</template>

<style lang="sass" scoped>
  section.comic
    text-align: center
    padding: 40px
    display: flex
    flex-direction: column
    flex-wrap: wrap
    align-items: center
    justify-content: center

    img
      object-fit: contain
      width: 600px
      max-width: 100%
      border-radius: 5px

      &[loading]
        width: 0
        height: 0

    div.controls
      margin-top: 25px
      display: flex
      align-items: center
      justify-content: center

      *
        color: var(--sidebar-link)

      .blue
        color: var(--active-link)

      a
        margin: 0 5px
        margin-top: 2px

        &.hide
          pointer-events: none
          color: gray
          opacity: 0.6

      p
        margin: 0 5px

      @media (min-width: 400px)
        font-size: 18px

    p.note
      margin-top: 30px
      white-space: pre-wrap

  .title
    font-size: 1rem
    margin-bottom: 25px
    font-weight: bold
    color: var(--black)
</style>

<script>
  import { comics } from '../../config.js'

  const renderedComics = comics.map(
    ({ name, issues }) => ({
      name,
      issues: issues.map(
        ({ location, title, slides }, key) => ({
          title, key,
          slides: slides.map( slide => {
            return typeof slide === 'string'
              ? { 
                url: require(`@/${location}/${slide}`)
              } : {
                ...slide,
                url: require(`@/${location}/${slide.url}`)
              }
          })
        })
      )
    })
  )

  export default {
    name: 'Comic',

    data () {
      return {
        loading: false,
      }
    },

    computed: {
      comic () {
        return renderedComics.find(({ name }) => name === this.$route.params.name)
      },

      issue () {
        return this.comic.issues[this.$route.params.issue]
      },

      slide () {
        return this.issue.slides[this.$route.params.slide]
      },

      key () {
        return Number(this.$route.params.slide)
      },
    },

    methods: {
      getSlideRoute ( index ) {
        return `/comic/${this.comic.name}/${this.issue.key}/${index}`
      },

      previousSlide () {
        const { getSlideRoute, key, $router } = this

        if (key > 0) $router.push(
          getSlideRoute(key - 1)
        )
      },

      nextSlide () {
        const { getSlideRoute, key, $router, issue } = this

        if (key < issue.slides.length - 1) $router.push(
          getSlideRoute( key + 1 )
        )
      },

      keydownListener ({ key }) {
        if (key === 'ArrowLeft') this.previousSlide()
        if (key === 'ArrowRight') this.nextSlide()
      },

      unloadImage () {
        this.loading = true
      },

      onImageLoad () {
        this.loading = false
      },
    },

    mounted () {
      window.addEventListener('keydown', this.keydownListener)
    },

    destroyed () {
      window.removeEventListener('keydown', this.keydownListener)
    },

    beforeRouteUpdate (to, from, next) {
      this.unloadImage()
      next()
    },

    watch: {
      $route () {
        window.scrollTo(0, 0)
      },
    },
  }
</script>
